module.exports = __webpack_public_path__ + "static/media/ideal_website.1579f96e.webp";